import { getDataAttribute, getOffsetTop } from './utils'

export default class Carousel {
  constructor($el) {
    this.$el = $el

    this.defaultActiveItem = 1;

    this.$items = this.initializeSlides();

    this.$transitionOverlay = this.$el.querySelector('.carousel-transition-overlay')
    this.$navigationItems = Array.from(this.$el.querySelectorAll('[data-move-to-item]'));

    this.$navigationItems.forEach($item => {
      $item.addEventListener('click', () => {
        let moveTo = parseInt(getDataAttribute($item, 'moveToItem'));

        this.switchCamp(moveTo)
      });
    })

    this.$activeItem = this.getItem(this.defaultActiveItem)
    this.$activeItem.activate();
  }

  initializeSlides(){
   // Abstract.
  }

  switchCamp(newItem) {
    let $newItem = this.getItem(newItem)

    const onTransitionEnd = () => {
      this.$transitionOverlay.removeEventListener('transitionend', onTransitionEnd)

      this.$activeItem.deactivate();
      $newItem.activate();

      let offsetTop = getOffsetTop($newItem.getEl().querySelector('.carousel-scroll-to-slide'))

      this.$activeItem = $newItem
      window.scrollTo(0, offsetTop)

      this.$transitionOverlay.classList.remove('active')
    }

    this.$transitionOverlay.addEventListener('transitionend', onTransitionEnd)
    this.$transitionOverlay.classList.add('active')
  }

  getItem(itemNr) {
    return this.$items[itemNr];
  }
}